import { Entity, RequestStatus, RequestStatusType } from '../../state/types';

type GetId = (type: RequestStatusType, entityId: Entity['id']) => RequestStatus['id'];
export const getId: GetId = (type, entityId) => btoa(`${type}-${encodeURIComponent(entityId)}`);
